import { useEffect, useState } from 'react';
// Import the Unread Icon
import UnreadMessageIcon from '../Icons/UnreadMessageIcon'; 
// We import the same CSS file to reuse the 'patient' and 'patientList' classes
import '../PrimaryPatient/PatientList/PatientList.css'; 

const ProjectList = ({ projects, selectProject, activeProject, unreadProjectIds = [] }) => {
  const [allProjects, setAllProjects] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (projects) {
      setAllProjects(projects);
      setLoader(true);
    }
  }, [projects]);

  if (loader) {
    return (
      <div className='patientList'>
        {allProjects.map((project) => {
          // Check if this is the currently selected project for highlighting
          const isActive = activeProject && activeProject.Id === project.Id;
          
          // Check if this project has unread messages
          // We convert both to strings/integers safely to ensure they match
          const hasUnread = unreadProjectIds.some(id => String(id) === String(project.Id));

          return (
            <div
              // We keep the className 'patient' to inherit the card styling from PatientList.css
              className='patient' 
              key={project.Id}
              onClick={() => {
                selectProject(project);
              }}
              // Inline style to show active state
              style={{
                backgroundColor: isActive ? '#e9ecef' : 'white',
                borderLeft: isActive ? '4px solid #0d6efd' : 'none',
              }}
            >
              <div>
                <div className='row align-items-center'>
                  {/* Project Name Column */}
                  <div className='col-10'>
                    <h6 style={{ margin: 0 }}>
                      {project.Name}
                    </h6>
                  </div>
                  
                  {/* Notification Icon Column */}
                  <div className='col-2 d-flex justify-content-end'>
                    {hasUnread && (
                      <div title="Unread messages">
                         <UnreadMessageIcon />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        
        {/* Empty State Handle */}
        {allProjects.length === 0 && (
           <div className="text-center p-3 small opacity-50">
             No projects found.
           </div>
        )}
      </div>
    );
  } else {
    return <div>Loading</div>;
  }
};

export default ProjectList;